import { Routes } from '@angular/router';
import { AutoReloadGuard } from './guards/auto-reload.guard';
import { NotFoundGuard } from './guards/not-found.guard';

const allRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./chrome-extension/routes').then(m => m.routes),
    data: { noIndex: true },
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
    data: { noIndex: true },
  },
];

export const ChromeExtensionRoutes: Routes = [
  {
    path: '',
    children: allRoutes,
    runGuardsAndResolvers: 'always',
    canActivate: [AutoReloadGuard],
  },
];
